import { selectCurrentNotification, selectNotificationsError, selectNotificationsLoading } from '../../store/selectors';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from 'store/store';
import { clearCurrentNotification } from '../../store/notifications';
import { fetchNotificationById } from '../../store/actions';
import { useEffect } from 'react';

export const useNotification = (id: number) => {
  const dispatch = useDispatch<AppDispatch>();
  const notification = useSelector(selectCurrentNotification);
  const loading = useSelector(selectNotificationsLoading);
  const error = useSelector(selectNotificationsError);

  useEffect(() => {
    if (id) {
      dispatch(fetchNotificationById(id));
    }
    return () => {
      dispatch(clearCurrentNotification());
    };
  }, [dispatch, id]);

  return { notification, loading, error };
};
